<div class="wrap-end">
    <h3>The meeting has ended</h3>
    <!-- <button routerLink="/meetings" class="btn btn-primary">Home</button> -->
</div>
